import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem, List, ListItemButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function CategoriaFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [classeEstabelecimentos, setClasseEstabelecimentos] = useState([]);
  const open = Boolean(anchorEl);
  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // Buscar categorias de estabelecimentos
    api
      .get("/tipo-estabelecimentos")
      .then((res) => {
        setClasseEstabelecimentos(res.data.tipoEstabelecimentos);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));
  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.tipo}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.provincia === ""}
              onClick={(event) => {
                props.setTipo("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>

            {classeEstabelecimentos?.map((classeEstabelecimento) => (
              <ListItemButton
                key={classeEstabelecimento._id}
                selected={props?.tipo === classeEstabelecimento?._id}
                onClick={(event) => {
                  props.setTipo(classeEstabelecimento?._id);
                  onClose();
                }}
              >
                {classeEstabelecimento?.designacao?.toUpperCase()}
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


